import type { admin_directory_v1 } from 'googleapis';
import { Vendors } from '../vendor.enum';
import { BaseAsset } from './base-asset.interface';

export const GoogleGroupTypes = {
  'ORG_UNIT': 'orgUnit',
  'GROUP': 'group',
} as const;

export type GoogleGroupType = (typeof GoogleGroupTypes)[keyof typeof GoogleGroupTypes];

export class GoogleGroupingData {
  type!: GoogleGroupType;
  aliases?: string[]; // Only available for groups
  description?: string; // Available for both
  email?: string; // Only available for groups
  membersCount?: number; // Only available for groups
  parentId?: string; // Only available for org units
  parentValue?: string; // Only available for org units
}

export class MicrosoftGroupingData {}

export class AppleGroupingData {}

export type GoogleOrgUnitSchema = admin_directory_v1.Schema$OrgUnit;

export type GoogleGroupSchema = admin_directory_v1.Schema$Group;

export type GoogleGroupingSchema = GoogleOrgUnitSchema | GoogleGroupSchema;

export const isOrgUnitSchema = (ggs: GoogleGroupingSchema): ggs is GoogleOrgUnitSchema => {
  return 'orgUnitId' in ggs || ggs.kind === 'admin#directory#orgUnit';
};

export const isGroupSchema = (ggs: GoogleGroupingSchema): ggs is GoogleGroupSchema => {
  return !isOrgUnitSchema(ggs);
};

/** @deprecated Use isOrgUnitSchema instead */
export const isGoogleGroupingSchemaGoogleOrgUnitSchema = isOrgUnitSchema;

/** @deprecated Use isGroupSchema instead */
export const isGoogleGroupingSchemaGoogleGroupSchema = isGroupSchema;

export class VendorGroupingData {
  [Vendors.GOOGLE]?: GoogleGroupingData;
  [Vendors.MICROSOFT]?: MicrosoftGroupingData;
  [Vendors.APPLE]?: AppleGroupingData;
}

export interface GoogleRawVendorGroupingData {
  data: GoogleGroupingSchema;
}

export type RawVendorGroupingData = {
  [Vendors.GOOGLE]?: GoogleRawVendorGroupingData;
  [Vendors.MICROSOFT]?: Record<string, unknown>;
  [Vendors.APPLE]?: Record<string, unknown>;
};

export class GroupingAsset extends BaseAsset {
  value!: string; // This would be the OU Path or group name
  vendorProperties!: VendorGroupingData;
  rawVendorProperties!: RawVendorGroupingData;
}
